export default {
      id: "smart_subscribe-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#smart_subscribe",
      toString: function () {
        return this.url;
      }
    }